import styled from "styled-components";

export const AuthStyle = styled.div`
  .login-container {
    background-color: white;
    width: 48vh;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding: 20px 60px;
    box-shadow: 0 0 30px rgba(247, 148, 29, 0.3); /* Add a box shadow */
    z-index: 1; /* Add a higher z-index to make the shadow visible */
  }
  .container-1 {
    height: 100vh;
    display: flex;
    flex: 1;
    justify-content: center;
    flex-direction: column;
  }
  .container-2 {
    justify-content: center;
    align-items: center;
    flex: 1;
    height: 100vh;
    display: flex;
  }

  .description {
    font-weight: 700;
    font-size: 2.2em;
    font-style: italic;
    margin: 2em 2em;
    color: white;
    font-family: medium-pro, sans-serif;
    text-align: center;
  }

  .text-errorfade {
    font-family: thin-pro, sans-serif;
    color: red;
    font-size: 14px;
    margin-left: 2px;
    opacity: 0;
    margin-bottom: 0;
  }
  .text-error2 {
    font-family: thin-pro, sans-serif;
    color: red;
    font-size: 14px;
    text-align: center;
    margin-bottom: 0;
  }

  .img-logo {
    width: 459px;
    height: 175px;
    align-self: center;
  }
  .body {
    background-color: hsl(30, 2%, 21%);
    display: flex;
    height: 100%;
    width: 100%;
  }

  .input-field {
    height: 5vh;
    margin-bottom: 5px;
    font-family: thin-pro, sans-serif;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }

  .error-input {
    height: 5vh;
    margin-bottom: 5px;
    font-family: thin-pro, sans-serif;
    border-color: red;
  }
  .form-text {
    font-size: 1rem;
    font-weight: 700;
    color: black;
    font-family: medium-pro, sans-serif;
  }

  .form-button {
    width: 32vh;
    background-color: #f28809;
    border-color: white;
    margin-top: 20px;
    margin-bottom: 10px;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 1rem;
    padding: 10px 0;
  }
  .form-button-disable {
    background-color: #bcb7b7;
  }

  .form-container {
    margin-top: 30px;
  }

  .btn-container {
    justify-content: center;
    display: flex;
    margin-top: 2vh;
    flex-direction: column;
    align-items: center;
  }

  .text-forgot {
    color: #231f20;
    font-weight: 600;
    font-size: 14px;
    text-align: right;
    text-decoration: none;
    font-family: thin-pro, sans-serif;
  }

  .text-login {
    margin: 2vh 0 2vh 0;
    font-family: medium-pro, sans-serif;
    font-size: 2rem;
  }

  /* For large devices */
  @media screen and (max-width: 1440px) {
    .img-logo {
      width: 400px;
      height: 150px;
    }

    .description {
      font-size: 1.7em;
    }

    .login-container {
      width: 55vh;
      padding: 20px 30px;
    }
    .input-field {
      height: 7vh;
    }
  }
  @media screen and (max-width: 1024px) {
    .img-logo {
      width: 41vh;
      height: 16vh;
    }

    .description {
      font-size: 1.6em;
    }
    .input-field {
      height: 7vh;
    }
  }

  /* For medium devices */
  @media screen and (max-width: 800px) {
    .body {
      flex-direction: column;
      justify-content: center;
      width: 100%;
    }
    .container-1 {
      width: 100%;
      margin-top: 10vh;
      height: 10vh;
    }

    .container-2 {
      width: 100%;
      height: 85vh;
    }

    .input-field {
      height: 8vh;
    }

    .description {
      text-align: center;
    }

    .img-logo {
      width: 27vh;
    }

    .description {
      font-size: 1em;
    }
  }

  @media screen and (max-width: 576px) {
    .body {
      flex-direction: column;
      justify-content: center;
      width: 100%;
    }

    .input-field {
      height: 8vh;
    }

    .container-1 {
      margin-top: 10vh;
      height: 10vh;
    }

    .container-2 {
      height: 85vh;
    }

    .login-container {
      padding: 20px 20px;
    }

    .form-button {
      width: 36vh;
    }

    .img-logo {
      width: 30vh;
    }
  }

  /* For small devices */
  @media screen and (max-width: 380px) {
    .container-1 {
      width: 100%;
    }
    .container-2 {
      width: 100%;
      height: 100vh;
    }

    .login-container {
      width: 60vh;
      height: 70vh;
      padding: 10px;
    }

    .text-login {
      font-size: 1.5rem;
    }

    .form-text {
      font-size: 1rem;
    }

    .input-field {
      height: 8vh;
    }

    .error-input {
      height: 8vh;
    }

    .text-error2 {
      font-size: 15px;
    }

    .form-button {
      width: 40vh;
    }

    .img-logo {
      width: 35vh;
    }
  }
`;
